import MarkdownMessage from '@gluedigital/markdown-message';
import { useIntl } from 'react-intl';
import verificationTextData from 'src/data/verificationTextData.json';

import './VerificationText.sass';

const VerificationText = () => {
	const { bd, lan } = verificationTextData;
	const intl = useIntl();

	return (
		<div id="verification-text">
			<MarkdownMessage id="verification-text" values={{ bd: intl.formatNumber(bd), lan }} />
		</div>
	);
};

export default VerificationText;
